import { c as _c } from "react/compiler-runtime";
import { useContext, useEffect } from 'react';
import { Breadcrumb, BreadcrumbsContext } from '../../context/BreadcrumbsContext';
export function useConfigureBreadcrumbs(breadcrumbs) {
  const $ = _c(4);
  const {
    setBreadcrumbs
  } = useContext(BreadcrumbsContext);
  let t0;
  let t1;
  if ($[0] !== breadcrumbs || $[1] !== setBreadcrumbs) {
    t0 = () => {
      setBreadcrumbs(breadcrumbs);
    };
    t1 = [setBreadcrumbs, breadcrumbs];
    $[0] = breadcrumbs;
    $[1] = setBreadcrumbs;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
}